import { Permission } from "types";
import { getTenantPermissions } from "api";

export interface PermissionsQueryParams {
  params: {
    tenantID?: number;
  };
}
export interface PermissionsLoaderData {
  _permissions: Promise<Permission[]>;
}

export default function permissionsLoader({
  params,
}: PermissionsQueryParams): PermissionsLoaderData {
  return {
    _permissions: getTenantPermissions(params.tenantID || 0),
  };
}
